import React from "react";
import Link from "next/link";
import { CardTitle, CardAction, CardActionIcons } from "shared/Slider/styled";
import { CardImage, CardBody, CardInfo, PaymentBackground, CardTime } from "styles/MainCards.styled";
import CardIcon from "components/CardIcon";
import { Icon } from "components/SvgIcons";
import { NoImage } from "styles/App.styled";
import CardCreatedBy from "./cardCreatedBy";
import { timeConvert } from "../../../helpers/getFormatedTime";
import cloudfront from "helpers/cloudfront";
import { getImageName } from "../../../helpers";

const TemplateForRecipes = ({
  type,
  context,
  setSaved,
  handleMouseMove,
  handleMouseDown,
  handleClick,
  isCreatorData,
  item,
}) => {
  return (
    <>
      <CardImage>
        <Link href={item.slug ? `/${item.slug}` : `/${context}/${item.id}`} passHref>
          <a onMouseMove={handleMouseMove} onMouseDown={handleMouseDown} onClick={handleClick}>
            {item.main_image ? (
              <img
                className="cloudfront"
                src={cloudfront({ href: item.main_image, size: "xMedium" })}
                id={item.id}
                data-path={context}
                alt={getImageName(item.main_image)}
              />
            ) : (
              <NoImage />
            )}
          </a>
        </Link>
        <PaymentBackground>
          {context === "recipe" &&
            (item.purchased ? (
              <Icon icon="newpurchase" />
            ) : item.private ? (
              <Icon icon="private" />
            ) : item.paid ? (
              `$${item.price}`
            ) : (
              "Free"
            ))}
          {context === "collection" &&
            (item.purchased ? <Icon icon="newpurchase" /> : item.paid ? `$${item.price}` : "Free")}
        </PaymentBackground>
        <CardAction>
          <CardActionIcons>
            <CardIcon
              id={item.id}
              icon={item.saved ? "savedslide" : "saveslide"}
              type={type}
              setSaved={setSaved}
              action={"save"}
            />
          </CardActionIcons>
          <CardTime>{item.recipe_creator ? timeConvert(item.total_time) : `${item.recipes_count} recipes`}</CardTime>
        </CardAction>
      </CardImage>
      <CardBody>
        <Link href={`/${context}/${item.id}`} passHref>
          <a onMouseMove={handleMouseMove} onMouseDown={handleMouseDown} onClick={handleClick}>
            <CardTitle id={item.id} data-path={context}>
              {item.title || `${item.first_name} ${item.last_name}`}
            </CardTitle>
          </a>
        </Link>
        {!isCreatorData && (
          <CardInfo>
            <CardCreatedBy
              elementType={item.recipe_creator || item.collection_creator}
              handleMouseMove={handleMouseMove}
              handleMouseDown={handleMouseDown}
              handleClick={handleClick}
            />
          </CardInfo>
        )}
      </CardBody>
    </>
  );
};

export default React.memo(TemplateForRecipes);
